import React, {PropTypes} from 'react';

import './arrow.css';

const Arrow = ({onClick, direction, label}) => (
  <div className={`arrow arrow-${direction}`} onClick={onClick}>
    {label}
  </div>
);

Arrow.displayName = 'Arrow';
Arrow.propTypes = {
  onClick: PropTypes.func.isRequired,
  direction: PropTypes.oneOf(['prev', 'next']).isRequired,
  label: PropTypes.string.isRequired,
};

export const Prev = ({onClick}) => (
  <Arrow direction="prev" onClick={onClick} label="Previous" />
);

Prev.displayName = 'Prev';
Prev.propTypes = {
  onClick: PropTypes.func.isRequired
};

export const Next = ({onClick}) => (
  <Arrow direction="next" onClick={onClick} label="Next" />
);

Next.displayName = 'Next';
Next.propTypes = {
  onClick: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/arrow/Arrow.js